import { Component, OnInit, HostListener } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UsuariModel } from '../../admin/models/admin.model';
import { DialogService } from '../../shared/services/dialog.service';
import { AlertService } from 'src/app/shared/services/alert.service';

@HostListener('window:beforeunload', [ '$event' ])

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  inscripcioOberta = true;
  avui:Date = new Date();

  usuari: UsuariModel = new UsuariModel();

  iPeticioActiva:number = -1;
  nomFaseAnterior = ['', 'Dades personals', 'Peticions', 'Mèrits', 'Veure sol·licitud', 'Tramitar'];
  nomFaseSeguent = ['', 'Dades personals', 'Iniciar sol·licitud', 'Següent', 'Enviar sol·licitud', 'Finalitzar'];
  faseAnterior:number = 0;
  faseSeguent:number = 0;
  faseSolicitud:number = 0;  

  nomArxiu!: string;
  teDoc:boolean[] = [];

  // control si hi a modificacions, per activar botó de "desar" i avisar al sortir
  tocat:boolean = false;
  // espera mentre pujent dades
  pujant:boolean = false;

  constructor(
    public auth: AuthService,
    private router: Router,
    private alert: AlertService,
    private popup: DialogService) { }

  ngOnInit() {

    this.carregaDades(true);

  }

  carregaDades(inicial:boolean = false) {
  }

  estaAutenticat() {
    return this.auth.estaAutenticat();
  }

  salir() {
    this.auth.logout();
    this.router.navigateByUrl('login');
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.tocat) {
        return this.popup.confirm('Canvis pendents', 'Hi han canvis pendents de desar.\nSi continua sortint es perdran els canvis.');
    }
    return true;
}
}
